var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "habla-a 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7694 11.575C42.9833 11.575 56.1778 1.62219 65.4361 1.62219C74.6944 1.62219 94.1389 6.94442 94.1389 49.5361C94.1389 92.1278 67.9806 98.3778 57.7972 98.3778C10.1111 98.3805 -10.2583 11.575 23.7694 11.575Z",
    fill: "#FBE2E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M86.6111 19.7833C84.3139 19.7833 82.4444 17.9138 82.4444 15.6166C82.4444 13.3194 84.3139 11.45 86.6111 11.45C88.9083 11.45 90.7778 13.3194 90.7778 15.6166C90.7778 17.9138 88.9083 19.7833 86.6111 19.7833ZM86.6111 14.2277C85.8472 14.2277 85.2222 14.85 85.2222 15.6166C85.2222 16.3833 85.8472 17.0055 86.6111 17.0055C87.375 17.0055 88 16.3833 88 15.6166C88 14.85 87.375 14.2277 86.6111 14.2277Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.7029 71.516L16.6671 69.5518L20.5955 73.4802L18.6313 75.4444L14.7029 71.516Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.9852 82.8196L27.9494 80.8554L31.8797 84.7857L29.9155 86.7499L25.9852 82.8196Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.2099 84.771L18.1383 80.8426L20.1025 82.8068L16.1741 86.7352L14.2099 84.771Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.5044 73.4812L29.4327 69.5528L31.3969 71.517L27.4685 75.4454L25.5044 73.4812Z",
    fill: "#D586B0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M76.1944 28.3889V50.6945C76.1944 53.75 73.6944 56.25 70.6389 56.25H23.4167C21.1111 56.25 19.25 54.3889 19.25 52.0834V28.3889L45.3889 41.3334C46.8333 42.0556 48.6111 42.0556 50.0556 41.3334L76.1944 28.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M76.1944 25.6945V28.3889L50.0556 41.3334C48.6111 42.0556 46.8333 42.0556 45.3889 41.3334L19.25 28.3889V25.6945C19.25 23.3889 21.1111 21.5278 23.4167 21.5278H72.0278C74.3333 21.5278 76.1944 23.3889 76.1944 25.6945Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.5 52.0834V31.4834L19.25 28.3889V52.0834C19.25 54.3889 21.1111 56.25 23.4167 56.25H29.6667C27.3611 56.25 25.5 54.3889 25.5 52.0834Z",
    fill: "#FBE2E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25.5 27.0306V25.6945C25.5 23.3889 27.3611 21.5278 29.6667 21.5278H23.4167C21.1111 21.5278 19.25 23.3889 19.25 25.6945V28.3889L45.3889 41.3334C46.8333 42.0556 48.6111 42.0556 50.0556 41.3334L50.8472 39.5834L25.5 27.0306Z",
    fill: "#9F4487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M65.7778 75C60.4167 75 56.0556 70.6389 56.0556 65.2778C56.0556 59.9167 60.4167 55.5555 65.7778 55.5555C71.1389 55.5555 75.5 59.9167 75.5 65.2778C75.5 70.6389 71.1389 75 65.7778 75ZM65.7778 59.7222C62.7139 59.7222 60.2222 62.2139 60.2222 65.2778C60.2222 68.3417 62.7139 70.8333 65.7778 70.8333C68.8417 70.8333 71.3333 68.3417 71.3333 65.2778C71.3333 62.2139 68.8417 59.7222 65.7778 59.7222Z",
    fill: "#571259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M65.7778 83.3334C60.3167 83.3334 55.2083 80.9028 51.7611 76.6611C48.3139 72.4195 46.9889 66.8639 48.1222 61.4167C49.5472 54.5889 55.0889 49.0473 61.9139 47.625C67.3556 46.4945 72.9194 47.8167 77.1583 51.2639C81.4 54.7084 83.8333 59.8195 83.8333 65.2778V68.75C83.8333 72.1973 81.0278 75 77.5833 75C74.1389 75 71.3333 72.1973 71.3333 68.75V57.6389H75.5V68.75C75.5 69.9 76.4361 70.8334 77.5833 70.8334C78.7306 70.8334 79.6667 69.9 79.6667 68.75V65.2778C79.6667 61.0778 77.7944 57.1473 74.5306 54.4945C71.2667 51.8389 66.9778 50.8195 62.7667 51.7028C57.5389 52.7917 53.2944 57.0362 52.2028 62.2667C51.325 66.4834 52.3417 70.7723 54.9944 74.0334C57.6472 77.2945 61.5778 79.1667 65.7778 79.1667V83.3334Z",
    fill: "#571259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M42.8611 58.3333H23.4167C19.9722 58.3333 17.1667 55.5306 17.1667 52.0833V25.6945C17.1667 22.2472 19.9722 19.4445 23.4167 19.4445H72.0278C75.4722 19.4445 78.2778 22.2472 78.2778 25.6945V42.3611H74.1111V25.6945C74.1111 24.5445 73.175 23.6111 72.0278 23.6111H23.4167C22.2694 23.6111 21.3333 24.5445 21.3333 25.6945V52.0833C21.3333 53.2333 22.2694 54.1667 23.4167 54.1667H42.8611V58.3333Z",
    fill: "#571259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M47.725 43.9639C46.6028 43.9639 45.4778 43.7083 44.4556 43.1944L18.325 30.2555L20.175 26.5222L46.3139 39.4667C47.1778 39.8972 48.275 39.8972 49.1222 39.4694L75.2694 26.5222L77.1194 30.2555L50.9806 43.2C49.9639 43.7083 48.8444 43.9639 47.725 43.9639Z",
    fill: "#571259"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.828e79a911ca2f594f2218878e555c57.svg";
export { ForwardRef as ReactComponent };